import {createRouter, createWebHistory} from 'vue-router';
import Home from '../views/home/Home.vue'
// @ts-ignore
import Subscribe from '../views/subscription/Subscribe.vue'
import SubscriptionConfirmation from '../views/subscription/SubscriptionConfirmation.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      name: 'Home',
      path: '/',
      component: Home,
      meta: {
        title: 'Goalkeeper Schoolmaster - EU Crisis Management Support and CSDP Training',
      }
    },
    {
      name: 'Subscription',
      path: '/course/subscriptionEmail',
      component: Subscribe
    },
    {
      name: 'Subscribe',
      path: '/course/subscribe',
      component: SubscriptionConfirmation
    },
    {
      name: 'Unsubscribe',
      path: '/course/unsubscribe',
      component: SubscriptionConfirmation
    },
    {
      name: 'Course',
      path: '/course/:id(\\d+)',
      component: () => import('@/views/course/Course.vue'),
      props: true,
      meta: {
        title: 'Schoolmaster Courses - Goalkeeper from EEAS',
      }
    },
    {
      name: 'Search',
      path: '/search',
      component: () => import('@/views/search/Search.vue'),
      meta: {
        title: 'Schoolmaster Courses - Goalkeeper from EEAS',
      }
    },
    {
      name: 'Bookmarks',
      path: '/bookmarks',
      component: () => import('@/views/bookmarks/Bookmarks.vue'),
      meta: {
        title: 'Bookmarked Courses',
      }
    },
    {
      name: 'About-Goalkeeper',
      path: '/about/goalkeeper',
      component: () => import('@/views/about/AboutGoalkeeper.vue'),
      meta: {
        title: 'About Goalkeeper',
      }
    },
    {
      name: 'About-Schoolmaster',
      path: '/about/schoolmaster',
      component: () => import('@/views/about/AboutSchoolmaster.vue'),
      meta: {
        title: 'About Schoolmaster'
      }
    },
    {
      path: '/:pathMatch(.*)*',
      component: () => import('@/components/error/error.vue'),
      meta: {
        title: 'Error Goalkeeper Schoolmaster',
      }
    }
  ],
  scrollBehavior() {
    document.getElementById('app')?.scrollIntoView({behavior:'smooth'})
  },
  strict: false
})

router.beforeEach((to, from) => {
  document.title = (to.meta?.title) as string ?? 'Goalkeeper - Schoolmaster from EEAS'
})

export default router